import { isClient, isServer } from "../../utils/ssr.utils/index.js";
var storage = isClient() ?
// browser's session storage for client
window.sessionStorage :
// session storage mock for SSR
{
  getItem: function getItem() {
    return null;
  },
  setItem: function setItem() {
    return null;
  },
  removeItem: function removeItem() {
    return null;
  },
  clear: function clear() {
    return null;
  }
};
export var $sessionStorage = {
  /**
   * get item from storage
   * @param {String} key - return JSON parsed value of a key
   * @return {*} - return JSON parsed value of a key
   */
  get: function get(key) {
    var value = storage.getItem(key);
    if (isServer()) {
      return value;
    }
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  },
  /**
   * set/update a key
   * @param {String} key
   * @param {*} val
   */
  set: function set(key, val) {
    if (isServer()) {
      return storage.setItem(key, val);
    }
    var value = typeof val === 'object' ? JSON.stringify(val) : val;
    return storage.setItem(key, value);
  },
  /**
   * Remove item based on key
   * @param {String} key
   */
  remove: function remove(key) {
    return storage.removeItem(key);
  },
  /**
   * clear the storage
   */
  clear: function clear() {
    return storage.clear();
  }
};